import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import imageService from '../../services/ImageServie';

const na = (v) => (v === null || v === undefined || v === '' ? 'N/A' : v);

function AdvertisementCard({ advertisement, servicesMap, onEdit, onDelete, onActivate, onChangeImage, assignPosition }) {
   const services = (advertisement.serviceIds || []).map(id => servicesMap[id] || '').filter(Boolean);
   
   const formatDate = (datetime) => {
        return datetime ? new Date(datetime).toLocaleString() : 'N/A';
   };

   return (
        <Card className="mb-3">
            <Row className='mx-0'>
                {advertisement.imageName && (
                    <Col md={4} className='px-0'>
                        <Card.Img className='rounded' variant="top"
                            src={`${imageService.getAdsImage}${advertisement.imageName || 'placeholder-image.jpg'}`}
                            alt={advertisement.companyName}
                        />
                    </Col>
                )}
                <Col md={advertisement.imageName ? 8 : 12}>
                    <Card.Body className='p-0 py-2 customer_adv_content'>
                        <Card.Title>{advertisement.companyName}</Card.Title>
                        <Row>
                            <Col md={12}>
                                <div className='customer_adv_Info'>
                                    <p>
                                        <strong>Plan:</strong> {advertisement.planName || 'N/A'}
                                        {' | '}<strong>AD Type:</strong> {advertisement.adType === 'paid' ? 'Paid' : 'Free'}
                                        {advertisement.adType === 'paid' && (
                                            <>
                                                {' | '}<strong>Plan Status:</strong> {advertisement.planStatus === 'expired' ? 'Expired' : 'Active'}
                                            </>
                                        )}
                                    </p>
                                    {advertisement.adType === 'paid' && (
                                        <p>
                                            <strong>Start Date:</strong> {advertisement.startDate ? new Date(advertisement.startDate).toLocaleDateString() : 'N/A'}
                                            {' | '}<strong>End Date:</strong> {advertisement.endDate ? new Date(advertisement.endDate).toLocaleDateString() : 'N/A'}
                                            {' | '}<strong>Amount:</strong> {advertisement.amount ?? 'N/A'}
                                            {' | '}<strong>Payment:</strong> {advertisement.paymentCycle === 'yearly' ? 'Yearly' : 'Monthly'}
                                        </p>
                                    )}
                                    <p><strong>Address:</strong> {[advertisement.address, advertisement.city, advertisement.state].filter(Boolean).join(', ') || 'N/A'}</p>
                                    <p><strong>Ph: </strong>{na(advertisement.phone)}  |  <strong>Work Type: </strong>{na(advertisement.shopType)} </p>
                                    <p><strong>Work Hrs:</strong> {na(advertisement.workingHours)}</p>
                                    <p><strong>Website:</strong> {advertisement.website ? <a href={advertisement.website}>{advertisement.website}</a> : 'N/A'} | <strong>Email:</strong> {na(advertisement.email)}</p>
                                    <p><strong>Created Date:</strong> {formatDate(advertisement.createdDate)}</p>
                                    <p><strong>Last Update:</strong> {formatDate(advertisement.updatedDate)}</p>
                                </div>

                                <div className="customer_adv_descr">
                                    <p className='mb-1 mt-1'><strong>Description:</strong> {na(advertisement.description)}</p>
                                    <p className='mb-1 mt-1'><strong>Highlight:</strong> {na(advertisement.highlight)}</p>
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="customer_adv_service">
                                    <p className='mb-1'><strong>Services:</strong> {services.join(' | ') || 'N/A'}</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-1 status-buttons mx-0">
                            <Col md={12} className='customer_adv_btn px-0'>
                                <Button variant="primary" onClick={() => onEdit(advertisement)}>Edit</Button>{' '}
                                <Button variant="danger" onClick={() => onDelete(advertisement.id)}>Delete</Button>{' '}
                                <Button variant={advertisement.active ? 'warning' : 'success'} onClick={() => onActivate(advertisement.id, advertisement.active)}>
                                    {advertisement.active ? 'Deactivate' : 'Activate'}
                                </Button>{' '}
                                <Button variant="secondary" onClick={() => onChangeImage(advertisement.id)}>Change Image</Button>{' '}
                                <Button variant="success" onClick={() => assignPosition(advertisement)}>Assign Position</Button> 
                            </Col>
                        </Row>
                    </Card.Body>
                </Col>
            </Row>
        </Card>
    );
}

export default AdvertisementCard;
